import { defineNuxtPlugin } from '#app'
import analyticsDirective from './analytics.directive'
import { analytics } from './core'
import mixpanel from 'mixpanel-browser'
import { loadEnvironmentConfig } from '@/configs/environments/config'

export default defineNuxtPlugin(async nuxtApp => {
  if (import.meta.client) {
    const config = await loadEnvironmentConfig()
    mixpanel.init(config.MIXPANEL_TOKEN, {
      api_host: 'https://api-eu.mixpanel.com'
    })
  }
  nuxtApp.vueApp.directive('analytics', analyticsDirective())

  return {
    provide: {
      analytics
    }
  }
})
